module.exports = __webpack_public_path__ + "img/ico-percent.836b15fd.svg";